import React from 'react';

const STATUS_STYLES = {
  Complete:   { bg: '#d1fae5', text: '#065f46', line: '#20c997' },
  Deployed:   { bg: '#dbeafe', text: '#1e40af', line: '#0d6efd' },
  Testing:    { bg: '#fef3c7', text: '#92400e', line: '#ffc107' },
};

const features = [
  { title: 'Site survey application', desc: 'AI Application to survey sites', status: 'Testing',  date: 'Nov 2026' },
  { title: 'PDF automation (PlanX)', desc: 'Plansets design automation', status: 'Testing',  date: 'Nov 2026' },
  { title: 'Planset AI reviewer', desc: 'Auto AI reviewer to review permits',   status: 'Testing',   date: 'Nov 2026' },
  { title: 'Site survey workflow', desc: 'Track site survey',   status: 'Testing',   date: 'Nov 2026' },
  { title: 'Billing Management', desc: 'Manage billing and payments',   status: 'Testing',   date: 'Nov 2026' },
];

const LayersIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2L2 7l10 5 10-5-10-5z" />
    <path d="M2 17l10 5 10-5" />
    <path d="M2 12l10 5 10-5" />
  </svg>
);

export default function UpcomingFeatures() {
  return (
    <div className="min-vh-45">

      {/* Card */}
      <div className="card border-0 shadow-sm" style={{ borderRadius: 16, width: '35vw' }}>
        <div className="card-body p-4" >
          {/* Card Header */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="d-flex align-items-center gap-3">
              <div className="d-flex align-items-center justify-content-center" style={{ width: 40, height: 40, backgroundColor: '#6f42c1', borderRadius: 10 }}>
                <LayersIcon />
              </div>
              <div>
                <h6 className="fw-bold mb-0">Upcoming Features</h6>
                <small className="text-muted">Sorted by progress</small>
              </div>
            </div>
            <span className="badge bg-light text-dark rounded-pill px-3 py-2">{features.length} total</span>
          </div>

          {/* Scrollable list — space for exactly 3 items */}
          <div style={{ maxHeight: 200, overflowY: 'auto', padding: '20px' }}>
            {features.map((f, i) => {
              const style = STATUS_STYLES[f.status];
              return (
                    <div key={i} className="d-flex gap-3 mb-3">
                  {/* Timeline line + dot */}
                  <div className="d-flex flex-column align-items-center position-relative">
                    <div style={{ width: 3, height: '100%', backgroundColor: style.line, borderRadius: 3 }} />
                    <div className="position-absolute" style={{ width: 8, height: 8, backgroundColor: '#0d6efd', borderRadius: '50%', top: 16 }} />
                  </div>

                  {/* Content */}
                  <div className="flex-grow-1 pb-3">
                    <div className="d-flex justify-content-between align-items-start">
                      <div>
                        <div className="d-flex align-items-center gap-2 mb-1">
                          <span className="fw-semibold">{f.title}</span>
                          <span className="badge rounded-pill" style={{ backgroundColor: style.bg, color: style.text }}>{f.status}</span>
                        </div>
                        <small className="text-muted">{f.desc}</small>
                      </div>
                      <small className="text-muted">{f.date}</small>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}